import { render } from "./TMPLabel.vue?vue&type=template&id=12dd10ae&scoped=true&ts=true"
import script from "./TMPLabel.vue?vue&type=script&lang=ts"
export * from "./TMPLabel.vue?vue&type=script&lang=ts"

import "./TMPLabel.vue?vue&type=style&index=0&id=12dd10ae&scoped=true&lang=css"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd10ae"]])

export default __exports__